// Art-side biome palettes for tiles and props. Environments stay dark and
// desaturated; accents are thin and controlled so gameplay colours read first.

import type { BiomeId } from '../../core/types';

export interface BiomeTileStyle {
  /** Interior plating. */
  base: number;
  baseHi: number;
  seam: number;
  /** Exposed-edge trim (lit lip → shadow). */
  trimHi: number;
  trimMid: number;
  trimLo: number;
  outline: number;
  /** Thin neon accent line under the top trim. */
  accent: number;
  accent2: number;
  accentAlpha: number;
  /** Non-colliding back wall. */
  back: number;
  backHi: number;
  backSeam: number;
  /** Pipes / props metal tint. */
  metal: number;
}

export const BIOME_TILE_STYLE: Record<BiomeId, BiomeTileStyle> = {
  // Wet dark concrete + steel, faded teal / pink neon.
  graveyard: {
    base: 0x1b222c,
    baseHi: 0x27313d,
    seam: 0x0b0f15,
    trimHi: 0xa9bacb,
    trimMid: 0x5b6a7e,
    trimLo: 0x2f3947,
    outline: 0x06080c,
    accent: 0x3fd6c8,
    accent2: 0xff5fa2,
    accentAlpha: 0.62,
    back: 0x0f141b,
    backHi: 0x161d26,
    backSeam: 0x080b10,
    metal: 0x4a5668,
  },
  // Riveted iron, warm orange heat seams.
  foundry: {
    base: 0x2a211c,
    baseHi: 0x382c25,
    seam: 0x110c0a,
    trimHi: 0xcdb39b,
    trimMid: 0x7c6757,
    trimLo: 0x40332b,
    outline: 0x090605,
    accent: 0xff7a1a,
    accent2: 0xffc04a,
    accentAlpha: 0.8,
    back: 0x17110e,
    backHi: 0x211914,
    backSeam: 0x0b0806,
    metal: 0x6b5446,
  },
  // Smooth black alloy, cyan / violet circuit lines.
  vault: {
    base: 0x0f131b,
    baseHi: 0x1a2130,
    seam: 0x04060a,
    trimHi: 0x94abc8,
    trimMid: 0x435168,
    trimLo: 0x1f2634,
    outline: 0x020305,
    accent: 0x35e8ff,
    accent2: 0x9b6bff,
    accentAlpha: 0.7,
    back: 0x080b11,
    backHi: 0x0e131c,
    backSeam: 0x030409,
    metal: 0x2c3646,
  },
};
